<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight material">
        <!-- 选项卡 -->
        <div class="g-tab">
            <a href="javascript:;">                            
                <div class="g-tab-item g-tab-item-active">官方素材</div>
            </a>
            <a href="javascript:;">
                <div class="g-tab-item">对战素材</div>
            </a>
            <a href="javascript:;">
                <div class="g-tab-item">UGC素材</div>
            </a>
        </div>
        <div class="material-types material-official">
            <div class="filters">
                <div class="filter-title f-clearfix">
                    <label class="spread-click">
                        <span class="filter-title-text">条件筛选</span>
                        <!-- 展开icon  添加类filter-title-spreaded -->
                        <div class="filter-title-spread"></div>
                    </label>
                    <!-- 获取焦点后的状态  添加类 filter-search-contain-focus-->
                    <div class="filter-search-contain f-fr">
                        <input class="filter-search-input" type="text" name="" id="" value="" placeholder="请输入要搜索的内容"/>
                        <div class="filter-search-icon f-fr"></div>
                    </div>
                </div>
                <div class="filter-select">
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">格式</span>
                        <ul class="filter-type-details-list f-fr">
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">类型</span>
                        <ul class="filter-type-details-list f-fr">
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">职业</span>
                        <ul class="filter-type-details-list f-fr">
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details">
                        <span class="filter-type-details-title f-hide-col-1">英雄</span>
                        <ul class="filter-type-details-list">
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item margin-right-0">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 长选择框添加类  filter-type-details-item-long-->
                            <li class="filter-type-details-item filter-type-details-item-long">
                                <a class="item-width f-hide-col-1" href="javascript:">王者高校联盟王者高校联盟王者高校联盟</a>
                            </li>
                        </ul>
                    </div>	
                </div>
            </div>	
            <div class="filter-result-contain">
                <div class="filter-result-title f-clearfix">
                    <span class="filter-rusult-new">最新排序</span>
                    <div class="filter-result-rank-icon">
                        <!-- 选中状态添加类filter-result-rank-up-active -->
                        <div class="filter-result-rank-up filter-result-rank-up-active"></div>
                        <!-- 选中状态添加类filter-result-rank-down-active -->
                        <div class="filter-result-rank-down"></div>
                    </div>
                    <span class="filter-rusult-hot">最热排序</span>
                    <div class="filter-result-rank-icon">
                        <!-- 选中状态添加类filter-result-rank-up-active -->
                        <div class="filter-result-rank-up"></div>
                        <!-- 选中状态添加类filter-result-rank-down-active -->
                        <div class="filter-result-rank-down"></div>
                    </div>
                    <span class="filter-result-title-text f-fr">已为您找到40个结果</span>
                </div>
                <ul class="filted-reusut-list">
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="material-types material-fight-against f-hide">
            <div class="filters">
                <div class="filter-title f-clearfix">
                    <label class="spread-click">
                        <span class="filter-title-text">条件筛选</span>
                        <!-- 展开icon  添加类filter-title-spreaded -->
                        <div class="filter-title-spread"></div>
                    </label>
                    <!-- 获取焦点后的状态  添加类 filter-search-contain-focus-->
                    <div class="filter-search-contain f-fr">
                        <input class="filter-search-input" type="text" name="" id="" value="" placeholder="请输入要搜索的内容"/>
                        <div class="filter-search-icon f-fr"></div>
                    </div>
                </div>
                <div class="filter-select">
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">格式</span>
                        <ul class="filter-type-details-list f-fr">
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">类型</span>
                        <ul class="filter-type-details-list f-fr">
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">职业</span>
                        <ul class="filter-type-details-list f-fr">
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details">
                        <span class="filter-type-details-title f-hide-col-1">英雄</span>
                        <ul class="filter-type-details-list">
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item margin-right-0">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 长选择框添加类  filter-type-details-item-long-->
                            <li class="filter-type-details-item filter-type-details-item-long">
                                <a class="item-width f-hide-col-1" href="javascript:">王者高校联盟王者高校联盟王者高校联盟</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>	
            <div class="filter-result-contain">
                <div class="filter-result-title f-clearfix">
                    <span class="filter-rusult-new">最新排序</span>
                    <div class="filter-result-rank-icon">
                        <!-- 选中状态添加类filter-result-rank-up-active -->
                        <div class="filter-result-rank-up filter-result-rank-up-active"></div>
                        <!-- 选中状态添加类filter-result-rank-down-active -->
                        <div class="filter-result-rank-down"></div>
                    </div>
                    <span class="filter-rusult-hot">最热排序</span>
                    <div class="filter-result-rank-icon">
                        <!-- 选中状态添加类filter-result-rank-up-active -->
                        <div class="filter-result-rank-up"></div>
                        <!-- 选中状态添加类filter-result-rank-down-active -->
                        <div class="filter-result-rank-down filter-result-rank-down-active"></div>
                    </div>
                    <span class="filter-result-title-text f-fr">已为您找到40个结果</span>
                </div>
                <ul class="filted-reusut-list">
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                </ul>
            </div>
        </div>
        <div class="material-types material-ugc f-hide">
            <div class="filters">
                <div class="filter-title f-clearfix">
                    <label class="spread-click">
                        <span class="filter-title-text">条件筛选</span>
                        <!-- 展开icon  添加类filter-title-spreaded -->
                        <div class="filter-title-spread"></div>
                    </label>
                    <!-- 获取焦点后的状态  添加类 filter-search-contain-focus-->
                    <div class="filter-search-contain f-fr">
                        <input class="filter-search-input" type="text" name="" id="" value="" placeholder="请输入要搜索的内容"/>
                        <div class="filter-search-icon f-fr"></div>
                    </div>
                </div>
                <div class="filter-select">
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">格式</span>
                        <ul class="filter-type-details-list f-fr">
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">类型</span>
                        <ul class="filter-type-details-list f-fr">
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details f-clearfix">
                        <span class="filter-type-details-title">职业</span>
                        <ul class="filter-type-details-list f-fr">
                            <li class="filter-type-details-item">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                            </li>
                            <li class="filter-type-details-item">
                                <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                            <!-- 选中状态 添加类 selected-filter-details -->
                            <li class="filter-type-details-item selected-filter-details">
                                <a class="item-width" href="javascript:">视频</a>
                            </li>
                        </ul>
                    </div>
                    <div class="filter-type-details">
                    <span class="filter-type-details-title f-hide-col-1">英雄</span>
                    <ul class="filter-type-details-list">
                        <li class="filter-type-details-item">
                            <a class="item-width" href="javascript:">视频</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width" href="javascript:">视频</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                        </li>
                        <!-- 选中状态 添加类 selected-filter-details -->
                        <li class="filter-type-details-item selected-filter-details">
                            <a class="item-width" href="javascript:">视频</a>
                        </li>
                        <li class="filter-type-details-item margin-right-0">
                            <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width" href="javascript:">视频</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width f-hide-col-1" href="javascript:">图片</a>
                        </li>
                        <li class="filter-type-details-item">
                            <a class="item-width f-hide-col-1" href="javascript:">皮肤</a>
                        </li>
                        <!-- 长选择框添加类  filter-type-details-item-long-->
                        <li class="filter-type-details-item filter-type-details-item-long">
                            <a class="item-width f-hide-col-1" href="javascript:">王者高校联盟王者高校联盟王者高校联盟</a>
                        </li>
                    </ul>
                </div>
            </div>
            </div>	
            <div class="filter-result-contain">
                <div class="filter-result-title f-clearfix">
                    <span class="filter-rusult-new">最新排序</span>
                    <div class="filter-result-rank-icon">
                        <!-- 选中状态添加类filter-result-rank-up-active -->
                        <div class="filter-result-rank-up"></div>
                        <!-- 选中状态添加类filter-result-rank-down-active -->
                        <div class="filter-result-rank-down filter-result-rank-down-active"></div>
                    </div>
                    <span class="filter-rusult-hot">最热排序</span>
                    <div class="filter-result-rank-icon">
                        <!-- 选中状态添加类filter-result-rank-up-active -->
                        <div class="filter-result-rank-up filter-result-rank-up-active"></div>
                        <!-- 选中状态添加类filter-result-rank-down-active -->
                        <div class="filter-result-rank-down"></div>
                    </div>
                    <span class="filter-result-title-text f-fr">已为您找到40个结果</span>
                </div>
                <ul class="filted-reusut-list">
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材[[ -->
                    <li class="filted-reusut-item">
                        <div class="video-contain">
                            <img class="video-img" src="~Assets/img/pages/v4/material.jpg"/>
                            <div class="video-play"></div>
                        </div>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <!-- 视频素材]] -->
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                    <li class="filted-reusut-item">
                        <img class="item-img" src="~Assets/img/pages/v4/material.jpg"/>
                        <!--
                            交互说明：光标放到li上显示,光标离开不显示
                        -->
                        <div class="hover-mask f-hide"></div>
                        <div class="item-intro">
                            <div class="item-intro-name f-hide-col-1">
                                <span class="item-intro-name-type">[最佳击杀]</span>KPL春季赛季后赛 神犬……
                            </div>
                            <div class="item-intro-message f-clearfix">
                                <a class="down-load-icon" href="javascript:"></a>
                                <span class="down-load-num">1000</span>
                                <span class="item-date f-fr">2018/06/05</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 分页 [[-->
        <div class="g-pagination">
            <a href="javascript:;" class="page-prev">&lt;</a>
            <div class="pager">
                <a href="javascript:;" class="number active-number">1</a>
                <a href="javascript:;" class="number">2</a>
                <a href="javascript:;" class="number">3</a>
                <a href="javascript:;" class="number">4</a>
                <a href="javascript:;" class="number">5</a>
            </div>
            <a href="javascript:;" class="page-next">&gt;</a>
            <div class="page-control">
                <span>跳转到</span>
                <input class="page-input" type="text">
                <span>页</span>
            </div>
        </div>
        <!-- 分页 ]]-->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/laboratory/material.scss';
</style>
<script>
// 测试代码
$(() => {
    		//tab切换
    		$(".g-tab-item").click(function(){
    			var i = $(this).parent().index();
    			$(".g-tab-item").removeClass("g-tab-item-active");
    			$(this).addClass("g-tab-item-active");
    			$(".material-types").addClass("f-hide")
    			$(".material-types").eq(i).removeClass("f-hide");
    		})
    		//出现/折叠过滤列表
    		$(".material-official .spread-click").click(function(){
    			if($(this).children(".filter-title-spread").hasClass("filter-title-spreaded")){
    				$(this).children(".filter-title-spread").removeClass("filter-title-spreaded")
    				$(".material-official .filter-select").slideUp(300)
    			}else{
    				$(this).children(".filter-title-spread").addClass("filter-title-spreaded")
    				$(" .material-official .filter-select").slideDown(300)
    			}
    			
    		})
    		$(".material-fight-against .spread-click").click(function(){
    			if($(this).children(".filter-title-spread").hasClass("filter-title-spreaded")){
    				$(this).children(".filter-title-spread").removeClass("filter-title-spreaded")
    				$(".material-fight-against .filter-select").slideUp(300)
    			}else{
    				$(this).children(".filter-title-spread").addClass("filter-title-spreaded")
    				$(".material-fight-against .filter-select").slideDown(300)
    			}
    			
    		})
    		$(".material-ugc .spread-click").click(function(){
    			if($(this).children(".filter-title-spread").hasClass("filter-title-spreaded")){
    				$(this).children(".filter-title-spread").removeClass("filter-title-spreaded")
    				$(".material-ugc .filter-select").slideUp(300)
    			}else{
    				$(this).children(".filter-title-spread").addClass("filter-title-spreaded")
    				$(".material-ugc .filter-select").slideDown(300)
    			}
    			
    		})
    		//搜索框获取焦点
    		$(".filter-search-input").focus(() => {
    			$(".filter-search-contain").addClass("filter-search-contain-focus");
    		})
    		$(".filter-search-input").blur(() => {
    			$(".filter-search-contain").removeClass("filter-search-contain-focus")
    		})
    		//解决safari下  子元素为inline-block时  间隔过大的问题
    		$('.filted-reusut-list,.filter-type-details-list,.filter-type-details').contents().filter(function() {
		    	return this.nodeType === 3;
    }).remove();
			
    //鼠标放到图片上添加半透明遮罩
    $(".filted-reusut-item").mouseenter(function(){
        $(this).find(".hover-mask").removeClass("f-hide")
    })
    $(".filted-reusut-item").mouseleave(function(){
        $(this).find(".hover-mask").addClass("f-hide")
    })
    		
    	})
// 测试代码
export default {
    data() {
        return {}
    },
    components: {},
    mounted(){
            
    },
    methods: {}
}
</script>